import { Box, Container, Grid } from "@mui/material";
import CartoonCardBasicSide from "components/CartoonCard/CartoonCardBasicSide";
import { DISCORD, TWITTER_FOLLOW, WEB_APP_LINK } from "utils/constants";
import SectionDivider from "./SectionDivider";
import mascot1 from "assets/images/mascots/41_rocket.webp";
import mascot2 from "assets/images/mascots/mascot2.webp";
import mascot3 from "assets/images/mascots/8_mustard.webp";

function Community({ id }) {
  return (
    <Container id={id}>
      <Box py={10}>
        <SectionDivider title={"Join the Community 📢"} withDivider />

        <Grid container spacing={10} justifyContent="center">
          {/* Discord Card */}
          <Grid item xs={12} md={12} lg={6}>
            <CartoonCardBasicSide
              title="Follow Us"
              description="I was mid-flirt, about to drop a smooth line — but something else dropped first. FartLab AI rated it a 762 for comedic timing. Follow us for more daily leaks. 💨 #FartLabMoments"
              color="#fc9e03"
              secondaryColor="white"
              tilt={true}
              baseTileAngle={0}
              image={mascot1}
              circularButtons={true}
              buttons={[
                {
                  label: "Follow us",
                  icon: "mdi:twitter",
                  onClick: () => window.open(TWITTER_FOLLOW, "_blank"),
                },
              ]}
              // image="/assets/discord-mascot.png" // Replace with actual cartoon character
            />
          </Grid>

          {/* Social Media Card */}
          <Grid item xs={12} md={12} lg={6}>
            <CartoonCardBasicSide
              title="FartLab Discord"
              description="Tried holding it in during a Zoom call... and it betrayed me at max volume. The Discord heard about it before my boss did. Come share your fart fails, rank champs, and join the chaos. 🎉💨 #FartConfessions"
              color="#1c86d7"
              secondaryColor="white"
              tilt={true}
              baseTileAngle={0}
              image={mascot2}
              circularButtons={true}
              buttons={[
                {
                  label: "Join Now",
                  icon: "mdi:discord",
                  onClick: () => window.open(DISCORD, "_blank"),
                },
              ]}
              // image="/assets/twitter-bird.png" // Replace with actual cartoon character
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <CartoonCardBasicSide
              title="Online App"
              description="I was in bed, cozy, watching rom-coms. Then — sudden rumble. FartLab's online app said 'volcanic activity detected'. Use it anywhere. Even when you're Netflixing and blasting. 💻💨 #AnalyzeThat"
              color="green"
              secondaryColor="white"
              tilt={true}
              baseTileAngle={0}
              image={mascot3}
              circularButtons={true}
              buttons={[
                {
                  label: "Launch App",
                  icon: "mdi:web",
                  onClick: () => window.open(WEB_APP_LINK, "_blank"),
                },
              ]}
              // image="/assets/twitter-bird.png" // Replace with actual cartoon character
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Community;
